import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { FilterHeader } from "@shared/table/headers/FilterHeader";
import { ColumnFiltersState } from "@tanstack/react-table";

const useOptions = () => {
    const { t } = useTranslation(["common"]);
    return [
        { key: "Live", label: t("common:label.live") },
        { key: "Beta", label: t("common:label.beta") },
        { key: "Nightly", label: t("common:label.nightly") },
        { key: "None", label: t("common:label.none") },
    ];
};

type Props = {
    columnFilters: ColumnFiltersState;
    setColumnFilters: Dispatch<SetStateAction<ColumnFiltersState>>;
};

export const ChannelHeader = ({ columnFilters, setColumnFilters }: Props) => {
    const { t } = useTranslation(["modals"]);
    const channelOptions = useOptions();
    const current = (columnFilters.find((f) => f.id === "channel")?.value as string[] | undefined) ?? [];

    return (
        <FilterHeader
            title={t("modals:filterDialog.variants.channel")}
            sortDisabled
            options={channelOptions}
            initialValues={Object.fromEntries(channelOptions.map((o) => [o.key, current.includes(o.key)]))}
            onSubmit={(values) => {
                const value = Object.keys(values).filter((k) => values[k]);
                setColumnFilters((prev) => {
                    const rest = prev.filter((f) => f.id !== "channel");
                    return value.length ? [{ id: "channel", value }, ...rest] : rest;
                });
            }}
        />
    );
};
